module.exports = require("core-js/library/fn/promise");